import { OptionDto } from "@/dtos";
import { FinancialInstitutionType } from "@/helpers/types";

const financialInstitutionTypes = [
    { value: FinancialInstitutionType.BANK, label: 'Banco' },
    { value: FinancialInstitutionType.COOPERATIVE, label: 'Cooperativa' },
] as OptionDto[];

export const getFinancialInstitutionTypeOptions = (): OptionDto[] => {
    return financialInstitutionTypes;
}

export const getFinancialInstitutionTypeOption = (value?: number): OptionDto => {
    return financialInstitutionTypes.find((x) => x.value == value) ?? financialInstitutionTypes[0];
}

export const getFinancialInstitutionTypeLabel = (value: number): string => {
    return financialInstitutionTypes.find((x) => x.value == value)?.label ?? financialInstitutionTypes[0].label;
}